import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import Tooltip from 'Components/Molecules/Tooltip/Tooltip';
import { forwardRef } from 'react';

const Icon = forwardRef(function Icon({ className, iconSize = 20, ...rest }, ref) {
    return (
        <svg
            ref={ref}
            width={iconSize}
            height={iconSize}
            fill="none"
            viewBox="0 0 20 20"
            className={cn('text-dark-blue cursor-help', className)}
            {...rest}
        >
            <circle cx="10" cy="10" r="8" fill="currentColor" opacity="0.05"></circle>
            <rect width="2" height="6" x="9" y="9" fill="currentColor" opacity="0.5" rx="1"></rect>
            <circle cx="10" cy="7" r="1" fill="currentColor" opacity="0.5"></circle>
        </svg>
    );
});

Icon.propTypes = {
    className: PropTypes.string,
    iconSize: PropTypes.number,
};

export default function IconInfo(props) {
    const { tooltip, ...iconProps } = props;

    if (!tooltip) {
        return <Icon {...iconProps} />;
    }

    return (
        <Tooltip label={tooltip}>
            <Icon {...iconProps} />
        </Tooltip>
    );
}

IconInfo.propTypes = {
    className: PropTypes.string,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    iconSize: PropTypes.number,
};
